import { Popup, Store } from "@bryntum/schedulerpro";

/**
 * 補助船員フィルターモーダル
 * @extends Popup
 */
export default class CrewsFilter extends Popup {
  static get $name() {
    return "CrewFilter";
  }

  static get configurable() {
    return {
      autoShow: false,
      scrollable: true,
      closeAction: "destroy",
      modal: true,
      closable: true,
      maximizable: true,
      applyClicked: undefined,
      header: "表示/非表示",
      // apply, cancelボタンを表示する
      bbar: {
        items: {
          close: {
            text: "save",
            onAction: ({ source }) => {
              // 親のポップアップから選択済みのリソース、表示用ストアを取得する
              const popup = source.up().up();
              const listItems = popup.listItemStore.data;
              const selectedItems = popup.items[0].selected;

              // 選択済みのリソースのvisibleフラグをtrueにして、コールバックを実行する
              let items = [];
              listItems.forEach(item => {
                items.push({
                  id: item.id,
                  name: item.name,
                  groupId: item.groupId,
                  groupName: item.groupName,
                  visible: selectedItems.findIndex("id", item.id) > -1,
                });
              });

              popup.applyClicked(items);
            },
          },
          apply: {
            text: "Cancel",
            onAction: "up.close",
          },
        },
      },
    };
  }

  /**
   * @param {Object} config - Popup configuration
   * @param {Object} config.data - schedulerproのresouceStoreのデータ
   * @param {Function} config.applyClicked - Applyボタンが押されたときのコールバック
   * @param {Function} config.source - Popupを表示するコンポーネント
   */
  constructor(config) {
    super(config);
  }

  construct(config) {
    // セレクトボックスに表示するデータを作成
    // requiredフラグがfalseのものを表示する
    let { data } = config;
    const listData = [];
    let selected = [];

    data.forEach(record => {
      listData.push({
        id: record.id,
        name: record.name,
        groupId: record.groupId,
        groupName: record.groupName,
        visible: record.visible,
      });
      if (record.visible) {
        selected.push(record.id);
      }
    });

    // セレクトボックス表示用データのストアを作成して、メンバ変数に保持する
    const store = new Store({
      fields: [
        { name: "id" },
        { name: "name" },
        { name: "groupId" },
        { name: "groupName" },
      ],
      groupers: [
        {
          field: "groupId",
          fn: (a, b) =>
            a.data.groupId.split("_")[1] - b.data.groupId.split("_")[1],
        },
      ],
      data: listData,
    });
    this.listItemStore = store;

    // セレクトボックスの設定
    config.items = {
      listFileld: {
        type: "list",
        displayField: "name",
        valueField: "id",
        multiSelect: true,
        selected,
        itemTpl: item => item.name,
        groupHeaderTpl(item) {
          const record = this.store.findRecord("groupId", item.groupId);
          return `<i class="b-fa b-fa-ship" style="margin-inline-end:.7em"></i>${record.groupName}`;
        },
        store,
      },
    };
    super.construct(config);
  }
}
